import { render } from "./escxstyfp.vue?vue&type=template&id=1954d6d4&scoped=true"
import script from "./escxstyfp.vue?vue&type=script&lang=js"
export * from "./escxstyfp.vue?vue&type=script&lang=js"

import "./escxstyfp.vue?vue&type=style&index=0&id=1954d6d4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1954d6d4"]])

export default __exports__